import * as React from 'react';
import { connect } from 'react-redux';
import ReactPlayer from 'node_modules/react-player';

export interface TutorialComponentProperties {
  readonly tutorialHeader: string;
  readonly mp4URL: string;
  readonly jpegURL: string;
}

export class TutorialComponent extends React.Component<TutorialComponentProperties> {
  render() {
    return (
      <div className="row center-xs">
        <div className="col">
          <h2>{this.props.tutorialHeader}</h2>
          <br />
          <p>
            <ReactPlayer
              url={this.props.mp4URL}
              controls={true}
              width="100%"
              height="auto"
              config={{
                file: {
                  attributes: {
                    poster: this.props.jpegURL
                  }
                }
              }}
            />
          </p>
        </div>
      </div>
    );
  }
}

export const Tutorial = connect();



// WEBPACK FOOTER //
// ./src/tutorial/tutorial.component.tsx